import {
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { ReactElement } from "react";
import Samples from "./Samples";
import SearchIcon from "@mui/icons-material/Search";
import { useRef, useState } from "react";
import { getMaskResults } from "../../../../api/llm";
import { LLMMaskResponse } from "../../../../types/llm";
import Results from "./Results";
import Disclaimer from "../Disclaimer";
import TaskInfo from "../TaskInfo";
import PredictingOverlay from "../PredictingOverlay";

interface MaskProps {
  index: number;
  tabValue: number;
}

const Mask = (props: MaskProps): ReactElement => {
  const { tabValue, index } = props;
  const [inputSample, setInputSample] = useState("");
  const [inputError, setInputError] = useState("");
  const [results, setResults] = useState<LLMMaskResponse | undefined>(
    undefined,
  );
  const [isPredicting, setIsPredicting] = useState(false);
  const isPredictingRef = useRef(false);

  const validateInputSample = (sample: string): boolean => {
    const maskCount = (sample.match(/\[MASK\]/g) || []).length;

    if (maskCount !== 1) {
      setInputError("A frase deve conter exatamente uma ocorrência de [MASK].");
      return false;
    }

    setInputError("");
    return true;
  };

  const handleSampleSelected = (sample: string) => {
    setInputSample(sample);
    validateInputSample(sample);
  };

  const handleInputSampleClick = () => {
    if (isPredictingRef.current) {
      return;
    }

    if (!validateInputSample(inputSample)) {
      setResults(undefined);
      return;
    }

    isPredictingRef.current = true;
    setIsPredicting(true);
    getMaskResults(inputSample, 5)
      .then((response) => {
        console.log(response);
        setResults(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        isPredictingRef.current = false;
        setIsPredicting(false);
      });
  };

  return tabValue === index ? (
    <Container sx={{ marginTop: 5 }} hidden={tabValue !== index}>
      <Disclaimer />
      <TaskInfo
        name="Fill-Mask"
        meaning="Fill masked word"
        description="Fill-mask predicts the most likely token for a masked position in a sentence. It helps test whether the language model can use the surrounding context to complete missing text."
      />
      <Grid container spacing={2} columns={10}>
        <Grid item xs={10} md={6}>
          <Paper
            elevation={2}
            sx={{
              padding: 3,
              border: "1px solid",
              borderColor: "divider",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <PredictingOverlay open={isPredicting} />
            <Stack spacing={2.5}>
              <TextField
                fullWidth
                multiline
                minRows={4}
                maxRows={6}
                label="Sentence"
                placeholder="Write a sentence with [MASK]"
                id="input-sample-text"
                value={inputSample}
                error={Boolean(inputError)}
                helperText={inputError || "Use exatamente uma ocorrência de [MASK]."}
                onChange={(e) => {
                  setInputSample(e.target.value);
                  if (inputError) {
                    validateInputSample(e.target.value);
                  }
                }}
              />
              <Button
                variant="contained"
                size="large"
                fullWidth
                startIcon={<SearchIcon />}
                disabled={isPredicting}
                onClick={() => handleInputSampleClick()}
              >
                Predict
              </Button>
            </Stack>
          </Paper>
          <Container sx={{ marginTop: 2 }}>
            <Results results={results} />
          </Container>
        </Grid>
        <Grid item xs={10} md={4}>
          <Stack spacing={1.5}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Examples
            </Typography>
            <Samples sampleSelectedCallback={handleSampleSelected}></Samples>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  ) : (
    <></>
  );
};

export default Mask;
